export const labels = {
  manageLabelsTitle: 'Zarządzaj etykietami',
  manageLabelsPara: 'Edytuj i zarządzaj etykietami w szablonie konfiguracji',
  code: 'Kod',
  codePlaceholder: 'Wprowadź kod etykiety',
  label: 'Etykieta',
  labelPlaceholder: 'Wprowadź nazwę etykiety',
  defaultValue: 'Wartość domyślna',
  defaultValuePlaceholder: 'Wprowadź wartość domyślną',
  isVisible: 'Widoczna',
  visible: 'Widoczna',
  hidden: 'Ukryta',
  edit: 'Edytuj',
  delete: 'Usuń',
  addLabel: 'Dodaj etykietę',
  save: 'Zapisz',
  cancel: 'Anuluj',
  noLabels: 'Ta konfiguracja nie ma zapisanych etykiet',
  deletingLabel: 'Usuń etykietę',
  deletingLabelDescription:
    'Czy na pewno chcesz usunąć tę etykietę? Ta operacja jest nieodwracalna.',
  addingNewLabel: 'Dodawanie nowej etykiety',
  updatedIndexSuccess: 'Kolejność etykiet została zaktualizowana',
  createdSuccess: 'Etykieta została utworzona',
  updatedSuccess: 'Etykieta została zaktualizowana',
  deletedSuccess: 'Etykieta została usunięta',
}
